import './FantasyHome.scss';
import React, { useEffect, useState }  from 'react';
import { SelectPlayersPage } from './SelectPlayersPage';
import { ClasificacionPage } from './ClasificacionPage';
import { ProfileFantasy } from './ProfileFantasy';
import { MyTeamPage } from './MyTeamPage';
import { useAuth } from '../../context/authContext'
import { Navigate } from 'react-router-dom'
import { doSignOut } from '../../firebase-service/auth'
import { useNavigate } from 'react-router-dom'
import CerrarSesionIcon from '../../assets/img/cerrar-sesion-icon.png'

import { FaExchangeAlt } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa";
import { FaTrophy } from "react-icons/fa";
import { FaShieldAlt } from "react-icons/fa";




export function FantasyHome() {
    
    const [selectedTab, setSelectedTab] = useState(1);
    const { userLoggedIn } = useAuth()
    const navigate = useNavigate();

    const changeTab = (index) => {
        setSelectedTab(index)
    };
    return (
        <main className="fantasy-container">
            {!userLoggedIn && (<Navigate to={'/fantasy/login'} replace={true} />)}
            <div className='nav-container'>
                <div className='tabs-container'>
                    <div className={selectedTab==0 ? 'tab-selected' : 'tab'} onClick={()=> changeTab(0)}>
                        <FaExchangeAlt />
                        <span>Mercado</span>
                    </div>
                    <div className={selectedTab==1 ? 'tab-selected' : 'tab'} onClick={()=> changeTab(1)}>
                        <FaShieldAlt />
                        <span>Equipo</span>
                    </div>
                    <div className={selectedTab==2 ? 'tab-selected' : 'tab'} onClick={()=> changeTab(2)}>
                        <FaTrophy />
                        <span>Clasificación</span>
                    </div>
                    <div className={selectedTab==3 ? 'tab-selected' : 'tab'} onClick={()=> changeTab(3)}>
                        <FaRegUser />
                        <span>Perfil</span>
                    </div>
                </div>
            </div>
             <div className='page-container'>
                {
                    selectedTab==0 ? <SelectPlayersPage changeTab={()=>changeTab(1)}/> 
                    : selectedTab==1 ? <MyTeamPage/> 
                    : selectedTab==2 ? <ClasificacionPage/> 
                    : <ProfileFantasy/>
                }
             </div>
        </main>
    );
}